import type React from "react";
import { useEffect, useState } from "react";

import { ExternalLinkModal } from "simplydo/react/components/ExternalLinkModal";

import { RemirrorEditor, type RemirrorProps } from "./Remirror";
import { EditMenu } from "./ui/EditMenu";
import { FloatingLinkToolbar } from "./ui/FloatingLinkToolbar";
import Mentions from "./ui/Mentions";

export type RemirrorMenuItem = {
  name: string;
  onClick?: (attrs: {
    name: string;
    commands: () => void;
    selectedText: string;
    isActive: boolean;
  }) => void;
  active?: boolean;
  forceEnable?: boolean;
};

export type BasicRichTextProps = {
  extraMenuItems?: Array<RemirrorMenuItem>;
  HelpText?: React.ReactNode;
  stickyMenu?: boolean;
  stickyMenuOffset?: number;

  hideMenu?: boolean;
  autoHideMenu?: boolean;
  historyEnabled?: boolean;
} & RemirrorProps;

export const BasicRichText = ({
  settings,
  options,
  readOnly,
  hideMenu,
  mentions,
  extraMenuItems,
  stickyMenu,
  stickyMenuOffset,
  historyEnabled,
  autoHideMenu = true,
  onSuggest,
  onMentionSelect,
  ...otherProps
}: BasicRichTextProps) => {
  const [followExternalLink, setFollowExternalLink] = useState(null);
  const [enabledExtensions, setEnabledExtensions] = useState(
    options.map((o) => o.name),
  );

  useEffect(() => {
    setEnabledExtensions(options.map((o) => o.name));
  }, [options]);

  return (
    <>
      <ExternalLinkModal
        open={followExternalLink !== null}
        href={followExternalLink}
        onClose={() => {
          setFollowExternalLink(null);
        }}
        onFollow={() => {
          setFollowExternalLink(null);
        }}
      />
      <RemirrorEditor
        options={options}
        readOnly={readOnly}
        settings={{
          ...settings,
          onExternalLink: (href) => {
            setFollowExternalLink(href);
          },
        }}
        {...otherProps}
      >
        {!readOnly && !hideMenu ?
          <EditMenu
            extraMenuItems={extraMenuItems}
            sticky={stickyMenu}
            stickyOffset={stickyMenuOffset}
            historyEnabled={historyEnabled}
            autoHideMenu={autoHideMenu}
          />
        : null}
        {!readOnly && enabledExtensions.includes("mention") ?
          <Mentions
            mentions={mentions}
            options={options}
            onMentionSelect={onMentionSelect}
            onSuggest={onSuggest}
          />
        : null}
        {!readOnly && !hideMenu && enabledExtensions.includes("link") ?
          <FloatingLinkToolbar />
        : null}
      </RemirrorEditor>
    </>
  );
};
